import { render, staticRenderFns } from "./P2PLayout.vue?vue&type=template&id=11e96a05&scoped=true&"
import script from "./P2PLayout.vue?vue&type=script&lang=js&"
export * from "./P2PLayout.vue?vue&type=script&lang=js&"
import style0 from "./P2PLayout.vue?vue&type=style&index=0&id=11e96a05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e96a05",
  null
  
)

export default component.exports